<template>
    <div class="tab-content">
        <el-tabs :value="value" @input="(val) => $emit('input', val)" @tab-click="handleClick">
            <el-tab-pane :disabled="!businessUnitPermission.viewTaskDetail"  :label="$t('bu_tab_info_detail')" name="first">
                <el-card v-if="selectedRow.type === 'Task'" class="box-card card panel">

                    <el-row class="info-title-color">
                        <el-col :span="11">
                            <div class="title">{{$t('bu_tab_info_detail_task')}}</div>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('bu_tab_info_detail_createdBy')}}
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                            <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                            <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                            <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                            <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                            <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                            <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                            <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                        </div>
                                        <span class="pointer" v-if="taskInfo.creatorUser" @mouseenter="getUserInfo(taskInfo.creatorUser.id)">{{taskInfo.creatorUser.user.fullName}}</span>
                                    </el-tooltip>
                                </el-col>
                            </el-row>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/project_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('bu_tab_info_detail_task')}}:
                                </el-col>
                                <el-col :span="15">
                                    <el-row class="info-color">
                                        <el-col :span="24">
                                            <strong>{{taskInfo.name}}</strong>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>

                            <div v-if="taskInfo.isReoccurring" class="title_reoccuring_deadline">Reoccuring</div>

                            <!-- <el-row v-if="taskInfo.isReoccurring" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/time-history.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('modal_recurringDetails')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                   <span>{{moment(taskInfo.reoccuringStartDate * 1000).format("D MMM YY, h:mm a")}}</span>
                                   <span>, {{taskInfo.repeatTaskInterval}} {{$t('general_hours')}}</span>
                                </el-col>
                            </el-row> -->

                            <el-row v-if="taskInfo.isReoccurring" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <!-- <img src="@/assets/img/info/time-history.svg" width="20px;" style="margin-right: 5px;"> -->
                                    <span>{{$t('modal_recurringBeginningOn')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                   <span>{{moment(taskInfo.reoccurringStaticStartDate * 1000).format("D MMM YY, h:mm a")}}</span>
                                </el-col>
                            </el-row>

                            <el-row v-if="taskInfo.isReoccurring" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <!-- <img src="@/assets/img/info/time-history.svg" width="20px;" style="margin-right: 5px;"> -->
                                    <span>{{$t('modal_recurringStartedOn')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                   <span>{{taskInfo.startedDate ? moment(taskInfo.startedDate * 1000).format("D MMM YY, h:mm a") : ''}}</span>
                                </el-col>
                            </el-row>

                            <el-row v-if="taskInfo.isReoccurring" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <!-- <img src="@/assets/img/info/time-history.svg" width="20px;" style="margin-right: 5px;"> -->
                                    <span>{{$t('modal_recurringRecursEvery')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                   <span>{{taskInfo.repeatTaskInterval / 24}} {{$t('general_days')}}</span>
                                </el-col>
                            </el-row>

                            <el-row v-if="taskInfo.isReoccurring" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <!-- <img src="@/assets/img/info/time-history.svg" width="20px;" style="margin-right: 5px;"> -->
                                    <span>{{$t('modal_recurringRecursFor')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <div v-if="taskInfo.reoccurringTotalCount > 0">
                                        <span>{{taskInfo.reoccurringTotalCount}} {{$t('general_periods')}}</span>
                                    </div>
                                    <div v-else>∞</div>
                                </el-col>
                            </el-row>

                            <el-row v-if="taskInfo.isReoccurring" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <!-- <img src="@/assets/img/info/time-history.svg" width="20px;" style="margin-right: 5px;"> -->
                                    <span>{{$t('modal_recurringCurrentPeriod')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <div v-if="taskInfo.reoccurringTotalCount > 0">
                                        <span>{{taskInfo.reoccurringCurrentIteration}} / {{taskInfo.reoccurringTotalCount}}</span>
                                    </div>
                                    <div v-else>
                                        <span>{{taskInfo.reoccurringCurrentIteration}} / ∞</span>
                                    </div>
                                </el-col>
                            </el-row>

                            <el-row v-if="taskInfo.isReoccurring" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <!-- <img src="@/assets/img/info/time-history.svg" width="20px;" style="margin-right: 5px;"> -->
                                    <span>{{$t('modal_recurringNextDueDate')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                   <span>{{moment(taskInfo.nextDueDate * 1000).format("D MMM YY, h:mm a")}}</span>
                                </el-col>
                            </el-row>

                            <div v-if="taskInfo.deadline" class="title_reoccuring_deadline">Deadline</div>

                            <el-row v-if="taskInfo.deadline" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <!-- <img src="@/assets/img/info/time.svg" width="20px;" style="margin-right: 5px;"> -->
                                    <span>{{$t('modal_deadlineDetails')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{moment(taskInfo.deadlineDate).format("D MMM YY, h:mm a")}}</span>
                                </el-col>
                            </el-row>

                            <el-row v-if="taskInfo.deadline" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <!-- <img src="@/assets/img/info/time.svg" width="20px;" style="margin-right: 5px;"> -->
                                    <span>{{$t('modal_deadlineCompletedDateTime')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.endedDate ? moment(taskInfo.endedDate * 1000).format("D MMM YY, h:mm a") : ''}}</span>
                                </el-col>
                            </el-row>

                            <!-- <div v-if="selectedRow.hasProgress" class="title_disabled">Billing</div>

                            <el-row v-if="selectedRow.hasProgress" style="margin-bottom: 5px; color: #ccc;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/project_icn.svg" width="20px;" style="margin-right: 5px;">
                                    Progress Billing Set:
                                </el-col>
                                <el-col :span="15">
                                    <el-row style="color: #ccc;">
                                        <el-col :span="24">
                                            <span>No</span>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row> -->

                            <el-divider></el-divider>

                            <div class="title">{{$t('bu_tab_info_detail_dates')}}</div>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/calendar_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('project_tab_info_detail_createdOn')}}
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span >{{moment(taskInfo.createDate * 1000).format("D MMM YY")}}</span>
                                </el-col>
                            </el-row>

                            <el-divider></el-divider>

                            <div class="title">{{$t('bu_tab_info_detail_documents')}}</div>

                            <!-- <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('bu_tab_info_detail_assignedTo')}}
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                            <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                            <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                            <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                            <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                            <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                            <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                            <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                        </div>
                                        <span class="pointer" v-if="taskInfo.leaderUser" @mouseenter="getUserInfo(taskInfo.leaderUser.id)">{{taskInfo.leaderUser.user.fullName}}</span>
                                    </el-tooltip>
                                </el-col>
                            </el-row> -->

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_taskDocumentsAdded')}}</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span v-if="taskInfo.addTaskDocument">{{$t('general_yes')}}</span>
                                    <span v-else>{{$t('general_no')}}</span>
                                </el-col>
                            </el-row>

                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.Sop" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_SOP')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.Sop.name}}</span>
                                </el-col>
                            </el-row>
                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.Policy" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_policy')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.Policy.name}}</span>
                                </el-col>
                            </el-row>
                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.HealthSafety" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_healthSafety')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.HealthSafety.name}}</span>
                                </el-col>
                            </el-row>
                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.Envirenmental" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_envirenmental')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.Envirenmental.name}}</span>
                                </el-col>
                            </el-row>
                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.RiskAssesment" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_riskAssesment')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.RiskAssesment.name}}</span>
                                </el-col>
                            </el-row>

                            <el-divider></el-divider>

                            <div class="title">{{$t('bu_tab_info_detail_notifications')}}</div>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/bell-checked.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_clientVendorNotifications')}}</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span v-if="taskInfo.allowExternalNotifications">{{$t('general_yes')}}</span>
                                    <span v-else>{{$t('general_no')}}</span>
                                </el-col>
                            </el-row>

                            <el-divider></el-divider>

                        </el-col>
                        <el-col :span="13">
                            <!-- <div v-if="selectedRow.hasProgress" class="title" style="text-align: center;">{{$t('bu_tab_info_detail_progress')}}</div> -->

                            <el-row type="flex" justify="end">
                                <el-col :span="8">
                                    <br>
                                    <el-row>
                                        <el-col :span="24" style="margin-bottom: 15px;">
                                            <div style="margin-left: 45px;">Status</div>
                                            <el-tooltip class="item" effect="dark" content="Status" placement="right">
                                                <el-tag size="medium" effect="plain" class="tag" :type="taskStatusStyle" style="width:130px; text-align: center;" v-html="taskStatusName"></el-tag>
                                            </el-tooltip>
                                        </el-col>
                                        <el-col :span="24">
                                            <div style="margin-left: 45px;">Priority</div>
                                            <el-tooltip class="item" effect="dark" content="Priority" placement="right">
                                                <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="taskInfo.priority.name"></el-tag>
                                            </el-tooltip>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="8" v-if="selectedRow.hasProgress">
                                    <div class="title">{{$t('bu_tab_info_detail_progress')}}</div>
                                    <el-progress type="dashboard" :percentage="Math.round(taskInfo.progress)" :color="colors"></el-progress>
                                </el-col>
                                <el-col :span="8">
                                    <br>
                                    <qr-code :text="'https://dev.totalflow.io' + this.$route.fullPath" :size="120"></qr-code>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>

                    <div class="panel__footer">
                        <div class="panel__team">

                            <el-row :gutter="20" style="margin-bottom: 0px;">
                                <el-col :span="14" :offset="0">
                                    <div class="panel__team_title">
                                        <i class="color h-center">
                                            <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                                            <div class="title">{{$t('bu_tab_info_detail_taskTeam')}}:</div>
                                            <!-- {{$t('bu_tab_info_detail_taskTeam')}}: -->
                                        </i>
                                    </div>
                                    <div>
                                        <div class="panel__team_item" v-for="item in businessUnitTaskCompanyUserList" :key="item.id">
                                            <el-tooltip placement="top">
                                                <div slot="content">
                                                    <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                                    <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                                    <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                                    <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                                    <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                                    <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                                    <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                                    <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                                </div>
                                                <span @mouseenter="getUserInfo(item.companyUserId)" v-html="item.userFullName"></span>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="10" :offset="0">
                                    <div class="title">{{$t('bu_tab_info_detail_permissions')}}:</div>
                                    <div class="panel__team_item" style="margin-left: 0px; cursor: default;" v-for="item in businessUnitTaskCompanyUserList" :key="item.id">
                                        <div>{{item.permissionPreset}}</div>
                                    </div>
                                </el-col>
                            </el-row>

                            <div class="panel__team_title" style="padding-top: 10px;">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('project_tab_info_detail_assignedTo')}}</div>
                                    <!-- {{$t('project_tab_info_detail_assignedTo')}}: -->
                                </i>
                            </div>
                            <div>
                                <div class="panel__team_item">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                            <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                            <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                            <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                            <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                            <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                            <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                            <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                        </div>
                                        <span class="pointer" v-if="taskInfo.leaderUser" @mouseenter="getUserInfo(taskInfo.leaderUser.id)">{{taskInfo.leaderUser.user.fullName}}</span>
                                    </el-tooltip>
                                </div>
                            </div>

                            <el-row :gutter="20">
                                <el-col :span="14" :offset="0">
                                    <div class="panel__team_title" style="padding-top: 10px;">
                                        <i class="color h-center">
                                            <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                                            <div class="title">{{$t('bu_tab_info_detail_businessUnitTeam')}}:</div>
                                            <!-- {{$t('bu_tab_info_detail_businessUnitTeam')}}: -->
                                        </i>
                                    </div>
                                    <div>
                                        <div class="panel__team_item" v-for="item in businessUnitCompanyUserList" :key="item.id">
                                            <el-tooltip placement="top">
                                                <div slot="content">
                                                    <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                                    <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                                    <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                                    <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                                    <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                                    <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                                    <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                                    <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                                </div>
                                                <span @mouseenter="getUserInfo(item.companyUserId)" v-html="item.userFullName"></span>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="10" :offset="0">
                                    <div class="title" style="padding-top: 10px;">{{$t('bu_tab_info_detail_permissions')}}:</div>
                                    <div class="panel__team_item" style="margin-left: 0px; cursor: default;" v-for="item in businessUnitCompanyUserList" :key="item.id">
                                        <div>{{item.permissionPreset}}</div>
                                    </div>
                                </el-col>
                            </el-row>

                        </div>
                        <div class="panel__clients">
                            <div class="panel__team_title">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/client_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('bu_tab_info_detail_taskClients')}}:</div>
                                    <!-- {{$t('bu_tab_info_detail_taskClients')}}: -->
                                </i>
                            </div>
                            <div>
                                <div class="panel__team_item" v-for="item in newClientList" :key="item.id">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="item.name">Name: {{item.name}}<br/></span>
                                            <span v-if="item.phone">Phone: {{item.phone}}<br/></span>
                                            <span v-if="item.street">Location: {{item.street}}<br/></span>
                                            <span v-if="item.email">Email: {{item.email}}<br/></span>
                                            <span v-if="item.fax">Fax: {{item.fax}}<br/></span>
                                            <span v-if="item.website">Website: <a :href="item.website" target="_blank">{{item.website}}</a><br/></span>
                                            <span v-if="item.facebook">Facebook: {{item.facebook}}<br/></span>
                                            <span v-if="item.linkedin">Linkedin: {{item.linkedin}}<br/></span>
                                        </div>
                                        <span class="vendor">{{item.name}} :</span>
                                    </el-tooltip>
                                    <div v-for="person in item.people" :key="person.id">
                                        <el-tooltip placement="top">
                                            <div slot="content">
                                                <span v-if="person.companyClientPerson.fullName">Name: {{person.companyClientPerson.fullName}}<br/></span>
                                                <span v-if="person.companyClientPerson.mobilePhone">Phone: {{person.companyClientPerson.mobilePhone}}<br/></span>
                                                <span v-if="person.companyClientPerson.address">Location: {{person.companyClientPerson.address}}<br/></span>
                                                <span v-if="person.companyClientPerson.email">Email: {{person.companyClientPerson.email}}<br/></span>
                                                <span v-if="person.companyClientPerson.skype">Skype: {{person.companyClientPerson.skype}}<br/></span>
                                                <span v-if="person.companyClientPerson.facebook">Facebook: <a :href="person.companyClientPerson.facebook" target="_blank">{{person.companyClientPerson.facebook}}</a><br/></span>
                                                <span v-if="person.companyClientPerson.linkedin">LinkedIn: <a :href="person.companyClientPerson.linkedin" target="_blank">{{person.companyClientPerson.linkedin}}</a><br/></span>
                                            </div>
                                            <span v-html="person.companyClientPerson.fullName"></span>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel__vendors">
                            <div class="panel__team_title">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/vendor_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('bu_tab_info_detail_taskVendors')}}:</div>
                                    <!-- {{$t('bu_tab_info_detail_taskVendors')}}: -->
                                </i>
                            </div>
                            <div>
                                <div class="panel__team_item" v-for="item in newVendorList" :key="item.id">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="item.name">Name: {{item.name}}<br/></span>
                                            <span v-if="item.phone">Phone: {{item.phone}}<br/></span>
                                            <span v-if="item.street">Location: {{item.street}}<br/></span>
                                            <span v-if="item.email">Email: {{item.email}}<br/></span>
                                            <span v-if="item.fax">Fax: {{item.fax}}<br/></span>
                                            <span v-if="item.website">Website: <a :href="item.website" target="_blank">{{item.website}}</a><br/></span>
                                            <span v-if="item.facebook">Facebook: {{item.facebook}}<br/></span>
                                            <span v-if="item.linkedin">Linkedin: {{item.linkedin}}<br/></span>
                                        </div>
                                        <span class="vendor">{{item.name}} :</span>
                                    </el-tooltip>
                                    <div v-for="person in item.people" :key="person.id">
                                        <el-tooltip placement="top">
                                            <div slot="content">
                                                <span v-if="person.companyVendorPerson.fullName">Name: {{person.companyVendorPerson.fullName}}<br/></span>
                                                <span v-if="person.companyVendorPerson.mobilePhone">Mobile Phone: {{person.companyVendorPerson.mobilePhone}}<br/></span>
                                                <span v-if="person.companyVendorPerson.workPhone">Work Phone: {{person.companyVendorPerson.workPhone}}<br/></span>
                                                <span v-if="person.companyVendorPerson.address">Location: {{person.companyVendorPerson.address}}<br/></span>
                                                <span v-if="person.companyVendorPerson.email">Email: {{person.companyVendorPerson.email}}<br/></span>
                                                <span v-if="person.companyVendorPerson.skype">Skype: {{person.companyVendorPerson.skype}}<br/></span>
                                                <span v-if="person.companyVendorPerson.facebook" >Facebook: <a :href="person.companyVendorPerson.facebook" target="_blank">{{person.companyVendorPerson.facebook}}</a><br/></span>
                                                <span v-if="person.companyVendorPerson.linkedin">Linkedin: <a :href="person.companyVendorPerson.linkedin" target="_blank">{{person.companyVendorPerson.linkedin}}</a><br/></span>
                                            </div>
                                            <span v-html="person.companyVendorPerson.fullName"></span>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </el-card>

                <el-card v-if="selectedRow.type === 'MasterTask'" class="box-card card panel">
                    <el-row class="info-title-color">
                        <el-col :span="11">
                            <div class="title">{{$t('bu_tab_info_detail_task')}}</div>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/project_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('bu_tab_info_detail_task')}}:
                                </el-col>
                                <el-col :span="15">
                                    <el-row class="info-color">
                                        <el-col :span="24">
                                            <strong>{{taskInfo.name}}</strong>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('bu_tab_info_detail_createdBy')}}
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                            <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                            <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                            <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                            <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                            <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                            <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                            <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                        </div>
                                        <span class="pointer" v-if="taskInfo.creatorUser" @mouseenter="getUserInfo(taskInfo.creatorUser.id)">{{taskInfo.creatorUser.user.fullName}}</span>
                                    </el-tooltip>
                                </el-col>
                            </el-row>

                            <el-divider></el-divider>

                            <div class="title">{{$t('bu_tab_info_detail_dates')}}</div>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/calendar_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('project_tab_info_detail_createdOn')}}
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span >{{moment(taskInfo.createDate * 1000).format("D MMM YY")}}</span>
                                </el-col>
                            </el-row>

                            <el-divider></el-divider>

                            <div class="title">{{$t('bu_tab_info_detail_documents')}}</div>

                            <!-- <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/user_icn.svg" width="20px;" style="margin-right: 5px;">
                                    {{$t('bu_tab_info_detail_assignedTo')}}
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                            <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                            <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                            <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                            <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                            <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                            <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                            <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                        </div>
                                        <span class="pointer" v-if="taskInfo.leaderUser" @mouseenter="getUserInfo(taskInfo.leaderUser.id)">{{taskInfo.leaderUser.user.fullName}}</span>
                                    </el-tooltip>
                                </el-col>
                            </el-row> -->

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_taskDocumentsAdded')}}</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span v-if="taskInfo.addTaskDocument">{{$t('general_yes')}}</span>
                                    <span v-else>{{$t('general_no')}}</span>
                                </el-col>
                            </el-row>

                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.Sop" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_SOP')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.Sop.name}}</span>
                                </el-col>
                            </el-row>
                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.Policy" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_policy')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.Policy.name}}</span>
                                </el-col>
                            </el-row>
                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.HealthSafety" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_healthSafety')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.HealthSafety.name}}</span>
                                </el-col>
                            </el-row>
                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.Envirenmental" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_envirenmental')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.Envirenmental.name}}</span>
                                </el-col>
                            </el-row>
                            <el-row v-if="taskInfo.addTaskDocument && taskInfo.dokList.RiskAssesment" style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/file-text.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_riskAssesment')}}:</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span>{{taskInfo.dokList.RiskAssesment.name}}</span>
                                </el-col>
                            </el-row>

                            <el-divider></el-divider>

                            <div class="title">{{$t('bu_tab_info_detail_notifications')}}</div>

                            <el-row style="margin-bottom: 5px;">
                                <el-col :span="9" class="h-center">
                                    <img src="@/assets/img/info/bell-checked.svg" width="20px;" style="margin-right: 5px;">
                                    <span>{{$t('project_tab_info_detail_clientVendorNotifications')}}</span>
                                </el-col>
                                <el-col :span="15" class="info-color">
                                    <span v-if="taskInfo.allowExternalNotifications">{{$t('general_yes')}}</span>
                                    <span v-else>{{$t('general_no')}}</span>
                                </el-col>
                            </el-row>

                            <el-divider></el-divider>
                        </el-col>
                        <el-col :span="13">
                            <!-- <div class="title" style="text-align: center;">{{$t('bu_tab_info_detail_progress')}}</div> -->

                            <el-row type="flex" justify="end">
                                <el-col :span="8">
                                    <br>
                                    <el-row>
                                        <el-col :span="24" style="margin-bottom: 15px;">
                                            <div style="margin-left: 45px;">Status</div>
                                            <el-tooltip class="item" effect="dark" content="Status" placement="right">
                                                <el-tag size="medium" effect="plain" class="tag" :type="taskStatusStyle" style="width:130px; text-align: center;" v-html="taskStatusName"></el-tag>
                                            </el-tooltip>
                                        </el-col>
                                        <el-col :span="24">
                                            <div style="margin-left: 45px;">Priority</div>
                                            <el-tooltip class="item" effect="dark" content="Priority" placement="right">
                                                <el-tag size="medium" effect="plain" class="tag" style="width:130px; text-align: center;" v-html="taskInfo.priority.name"></el-tag>
                                            </el-tooltip>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="8">
                                    <div class="title">{{$t('bu_tab_info_detail_progress')}}</div>

                                    <!-- <el-progress type="dashboard" :percentage="Math.round(taskInfo.progress)" :color="colors"></el-progress> -->
                                    <div style="margin-bottom: 15px;">
                                        <!-- <div class="circle">
                                            <div class="circle_number">{{taskInfo.doneChildTasksCount}}/{{taskInfo.childTasksCount}}</div>
                                        </div> Done/Sub Task -->

                                        <el-row :gutter="20">
                                            <el-col :span="24" :offset="0">{{taskInfo.childTasksCount}} - {{$t('general_subTask')}}</el-col>
                                        </el-row>

                                        <el-row :gutter="20">
                                            <el-col :span="24" :offset="0">{{taskInfo.fullProgressTasksCount}} - 100%</el-col>
                                        </el-row>

                                        <el-row :gutter="20">
                                            <el-col :span="24" :offset="0">{{taskInfo.doneChildTasksCount}} - {{$t('general_done')}}</el-col>
                                        </el-row>

                                        <!-- <div>{{$t('general_done')}} ({{taskInfo.doneChildTasksCount}}) / {{$t('general_subTask')}} ({{taskInfo.childTasksCount}})</div> -->
                                    </div>
                                    <div>
                                        <!-- <div class="circle">
                                            <div class="circle_number">{{taskInfo.fullProgressTasksCount}}/{{taskInfo.childTasksCount}}</div>
                                        </div> 100%/Sub Task -->

                                        <!-- <div>100% ({{taskInfo.fullProgressTasksCount}}) / {{$t('general_subTask')}} ({{taskInfo.childTasksCount}})</div> -->
                                    </div>
                                </el-col>
                                <el-col :span="8">
                                    <br>
                                    <qr-code :text="'https://dev.totalflow.io' + this.$route.fullPath" :size="120"></qr-code>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>

                    <div class="panel__footer">
                        <div class="panel__team">

                            <el-row :gutter="20" style="margin-bottom: 0px;">
                                <el-col :span="14" :offset="0">
                                    <div class="panel__team_title">
                                        <i class="color h-center">
                                            <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                                            <div class="title">{{$t('bu_tab_info_detail_taskTeam')}}:</div>
                                            <!-- {{$t('bu_tab_info_detail_taskTeam')}}: -->
                                        </i>
                                    </div>
                                    <div>
                                        <div class="panel__team_item" v-for="item in businessUnitTaskCompanyUserList" :key="item.id">
                                            <el-tooltip placement="top">
                                                <div slot="content">
                                                    <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                                    <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                                    <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                                    <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                                    <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                                    <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                                    <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                                    <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                                </div>
                                                <span @mouseenter="getUserInfo(item.companyUserId)" v-html="item.userFullName"></span>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="10" :offset="0">
                                    <div class="title">{{$t('bu_tab_info_detail_permissions')}}:</div>
                                    <div class="panel__team_item" style="margin-left: 0px; cursor: default;" v-for="item in businessUnitTaskCompanyUserList" :key="item.id">
                                        <div>{{item.permissionPreset}}</div>
                                    </div>
                                </el-col>
                            </el-row>

                            <div class="panel__team_title" style="padding-top: 10px;">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('project_tab_info_detail_assignedTo')}}</div>
                                    <!-- {{$t('project_tab_info_detail_assignedTo')}}: -->
                                </i>
                            </div>
                            <div>
                                <div class="panel__team_item">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                            <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                            <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                            <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                            <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                            <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                            <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                            <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                        </div>
                                        <span class="pointer" v-if="taskInfo.leaderUser" @mouseenter="getUserInfo(taskInfo.leaderUser.id)">{{taskInfo.leaderUser.user.fullName}}</span>
                                    </el-tooltip>
                                </div>
                            </div>

                            <el-row :gutter="20">
                                <el-col :span="14" :offset="0">
                                    <div class="panel__team_title" style="padding-top: 10px;">
                                        <i class="color h-center">
                                            <img src="@/assets/img/info/team_icn.svg" width="20px;" style="margin-right: 5px;">
                                            <div class="title">{{$t('bu_tab_info_detail_businessUnitTeam')}}:</div>
                                            <!-- {{$t('bu_tab_info_detail_businessUnitTeam')}}: -->
                                        </i>
                                    </div>
                                    <div>
                                        <div class="panel__team_item" v-for="item in businessUnitCompanyUserList" :key="item.id">
                                            <el-tooltip placement="top">
                                                <div slot="content">
                                                    <span v-if="tooltipUser.fullName">Name: {{tooltipUser.fullName}}<br/></span>
                                                    <span v-if="tooltipUser.phone">Phone: {{tooltipUser.phone}}<br/></span>
                                                    <span v-if="tooltipUser.street">Location: {{tooltipUser.street}}<br/></span>
                                                    <span v-if="tooltipUser.email">Email: {{tooltipUser.email}}<br/></span>
                                                    <span v-if="tooltipUser.fax">Fax: {{tooltipUser.fax}}<br/></span>
                                                    <span v-if="tooltipUser.website">Website: <a :href="tooltipUser.website" target="_blank">{{tooltipUser.website}}</a><br/></span>
                                                    <span v-if="tooltipUser.facebook">Facebook: <a :href="tooltipUser.facebook" target="_blank">{{tooltipUser.facebook}}</a><br/></span>
                                                    <span v-if="tooltipUser.linkedin">Linkedin: <a :href="tooltipUser.linkedin" target="_blank">{{tooltipUser.linkedin}}</a><br/></span>
                                                </div>
                                                <span @mouseenter="getUserInfo(item.companyUserId)" v-html="item.userFullName"></span>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="10" :offset="0">
                                    <div class="title" style="padding-top: 10px;">{{$t('bu_tab_info_detail_permissions')}}:</div>
                                    <div class="panel__team_item" style="margin-left: 0px; cursor: default;" v-for="item in businessUnitCompanyUserList" :key="item.id">
                                        <div>{{item.permissionPreset}}</div>
                                    </div>
                                </el-col>
                            </el-row>

                        </div>
                        <div class="panel__clients">
                            <div class="panel__team_title">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/client_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('bu_tab_info_detail_taskClients')}}:</div>
                                    <!-- {{$t('bu_tab_info_detail_taskClients')}}: -->
                                </i>
                            </div>
                            <div>
                                <div class="panel__team_item" v-for="item in newClientList" :key="item.id">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="item.name">Name: {{item.name}}<br/></span>
                                            <span v-if="item.phone">Phone: {{item.phone}}<br/></span>
                                            <span v-if="item.street">Location: {{item.street}}<br/></span>
                                            <span v-if="item.email">Email: {{item.email}}<br/></span>
                                            <span v-if="item.fax">Fax: {{item.fax}}<br/></span>
                                            <span v-if="item.website">Website: <a :href="item.website" target="_blank">{{item.website}}</a><br/></span>
                                            <span v-if="item.facebook">Facebook: {{item.facebook}}<br/></span>
                                            <span v-if="item.linkedin">Linkedin: {{item.linkedin}}<br/></span>
                                        </div>
                                        <span class="vendor">{{item.name}} :</span>
                                    </el-tooltip>
                                    <div v-for="person in item.people" :key="person.id">
                                        <el-tooltip placement="top">
                                            <div slot="content">
                                                <span v-if="person.companyClientPerson.fullName">Name: {{person.companyClientPerson.fullName}}<br/></span>
                                                <span v-if="person.companyClientPerson.mobilePhone">Phone: {{person.companyClientPerson.mobilePhone}}<br/></span>
                                                <span v-if="person.companyClientPerson.address">Location: {{person.companyClientPerson.address}}<br/></span>
                                                <span v-if="person.companyClientPerson.email">Email: {{person.companyClientPerson.email}}<br/></span>
                                                <span v-if="person.companyClientPerson.skype">Skype: {{person.companyClientPerson.skype}}<br/></span>
                                                <span v-if="person.companyClientPerson.facebook">Facebook: <a :href="person.companyClientPerson.facebook" target="_blank">{{person.companyClientPerson.facebook}}</a><br/></span>
                                                <span v-if="person.companyClientPerson.linkedin">LinkedIn: <a :href="person.companyClientPerson.linkedin" target="_blank">{{person.companyClientPerson.linkedin}}</a><br/></span>
                                            </div>
                                            <span v-html="person.companyClientPerson.fullName"></span>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel__vendors">
                            <div class="panel__team_title">
                                <i class="color h-center">
                                    <img src="@/assets/img/info/vendor_icn.svg" width="20px;" style="margin-right: 5px;">
                                    <div class="title">{{$t('bu_tab_info_detail_taskVendors')}}:</div>
                                    <!-- {{$t('bu_tab_info_detail_taskVendors')}}: -->
                                </i>
                            </div>
                            <div>
                                <div class="panel__team_item" v-for="item in newVendorList" :key="item.id">
                                    <el-tooltip placement="top">
                                        <div slot="content">
                                            <span v-if="item.name">Name: {{item.name}}<br/></span>
                                            <span v-if="item.phone">Phone: {{item.phone}}<br/></span>
                                            <span v-if="item.street">Location: {{item.street}}<br/></span>
                                            <span v-if="item.email">Email: {{item.email}}<br/></span>
                                            <span v-if="item.fax">Fax: {{item.fax}}<br/></span>
                                            <span v-if="item.website">Website: <a :href="item.website" target="_blank">{{item.website}}</a><br/></span>
                                            <span v-if="item.facebook">Facebook: {{item.facebook}}<br/></span>
                                            <span v-if="item.linkedin">Linkedin: {{item.linkedin}}<br/></span>
                                        </div>
                                        <span class="vendor">{{item.name}} :</span>
                                    </el-tooltip>
                                    <div v-for="person in item.people" :key="person.id">
                                        <el-tooltip placement="top">
                                            <div slot="content">
                                                <span v-if="person.companyVendorPerson.fullName">Name: {{person.companyVendorPerson.fullName}}<br/></span>
                                                <span v-if="person.companyVendorPerson.mobilePhone">Mobile Phone: {{person.companyVendorPerson.mobilePhone}}<br/></span>
                                                <span v-if="person.companyVendorPerson.workPhone">Work Phone: {{person.companyVendorPerson.workPhone}}<br/></span>
                                                <span v-if="person.companyVendorPerson.address">Location: {{person.companyVendorPerson.address}}<br/></span>
                                                <span v-if="person.companyVendorPerson.email">Email: {{person.companyVendorPerson.email}}<br/></span>
                                                <span v-if="person.companyVendorPerson.skype">Skype: {{person.companyVendorPerson.skype}}<br/></span>
                                                <span v-if="person.companyVendorPerson.facebook" >Facebook: <a :href="person.companyVendorPerson.facebook" target="_blank">{{person.companyVendorPerson.facebook}}</a><br/></span>
                                                <span v-if="person.companyVendorPerson.linkedin">Linkedin: <a :href="person.companyVendorPerson.linkedin" target="_blank">{{person.companyVendorPerson.linkedin}}</a><br/></span>
                                            </div>
                                            <span v-html="person.companyVendorPerson.fullName"></span>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </el-card>
            </el-tab-pane>

            <!-- about -->
            <el-tab-pane :disabled="!businessUnitPermission.viewTaskAbout" :label="$t('bu_tab_info_about')" name="about">
                <el-card class="box-card card panel">
                    <!-- <div v-html="!taskInfo.description ? emtyDescription : taskInfo.description"></div> -->
                    <aboutTask/>
                </el-card>
                <!-- (About) -->
            </el-tab-pane>

            <!-- to do -->
            <el-tab-pane :disabled="!businessUnitPermission.viewTaskToDo" :label="$t('bu_tab_info_toDo')" name="toDo">
                <el-card class="box-card card panel">
                    <!-- Current Service Under Development -->
                    <toDo/>
                </el-card>
            </el-tab-pane>

            <!-- progress -->
            <el-tab-pane :disabled="!businessUnitPermission.viewProgressNotes" v-if="selectedRow.type === 'Task' && selectedRow.isReoccuring === 1 || selectedRow.type === 'Task' && selectedRow.hasProgress === 1" :label="$t('bu_tab_progress')" name="progress">
                <el-card class="box-card card panel">
                    <DepProgressTab
                        ref="buProgressTab"
                        :selectedRow="selectedRow"
                        :businessUnitPermission="businessUnitPermission"
                        :progressData="progressData"
                        :selectedTaskForInfo="selectedTaskForInfo"
                        :selectedRowId="selectedRow.id"
                        @submit="getProjects" />
                </el-card>
            </el-tab-pane>

            <!-- documents -->
            <el-tab-pane :disabled="!businessUnitPermission.viewDocuments" v-if="selectedRow.type === 'Task' || selectedRow.type === 'MasterTask'" :label="$t('bu_tab_documents')" name="documents">
                <DocumentsTask  ref="docs" :businessUnitPermission="businessUnitPermission" :selectedRow="selectedRow"/>
            </el-tab-pane>

            <el-tab-pane :disabled="!businessUnitPermission.viewTaskHistory" :label="$t('bu_tab_info_history')" name="eight">
                <businessUnitTaskHistory/>
            </el-tab-pane>

        </el-tabs>
<!--        <div  class="book-mark-block pointer">-->

<!--            <div>-->
<!--                <div v-if="bookmarkList.info" @click="changeBookMark(bookmarkList.info, $route.query.companyId, selectedRow.businessUnitId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--                <div v-else @click="changeBookMark(bookmarkList.info, $route.query.companyId, selectedRow.businessUnitId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios';
  import businessUnitTaskHistory from '@/components/BusinessUnits/businessUnitTaskHistoryTab.vue'
  import DepProgressTab from '@/components/BusinessUnits/DepProgressTab.vue'
  import DocumentsTask from '@/components/BusinessUnits/DocumentsTask.vue'
  import moment from 'moment'
  import toDo from '@/components/BusinessUnits/toDo/toDo.vue'
  import aboutTask from '@/components/BusinessUnits/about/aboutTask.vue'


  export default  {
    name: 'BuInfoTaskTab',
    beforeMount() {

    },
    mounted(){

    },
    components: {
      businessUnitTaskHistory,
      DepProgressTab,
      DocumentsTask,
      toDo,
      aboutTask,
    },
    props: [
      'activeTaskInfoTab',
      'value',
      'activeProjectId',
      'taskInfo',
      // 'bookmarkList',
      'selectedRow',
      'businessUnitPermission',
      'progressData',
      'selectedTaskForInfo',
      'selectedRowId',
      'activeBusinessUnitId',
    ],
    computed: {
      ...mapGetters([
        'getStateId'
      ]),
    },
    data() {
      return {
        newVendorList:[],
        newClientList:[],
        tooltipUser:{},
        // Project
        businessUnitCompanyUserList: null,
        // Task
        businessUnitTaskCompanyUserList: null,
        businessUnitTaskCompanyClientList: null,
        businessUnitTaskCompanyVendorList: null,

        taskStatusName: '',
        taskStatusStyle: null,

        moment:moment,
        emtyDescription: this.$i18n.t('noDetailsProvided'),

        colors: [
          {color: '#e67112', percentage: 25},
          {color: '#63B8FF', percentage: 51},
          {color: '#63B8FF', percentage: 76},
          {color: '#0fd641 ', percentage: 100}
        ]
      }
    },
    watch: {
      // 'taskInfo.status': function (val) {
      //   switch(this.taskInfo.status) {
      //     case 1:
      //       this.taskStatusName = 'Created';
      //       this.taskStatusStyle = 'info';
      //       break;
      //     case 2:
      //       if ((Math.round(this.taskInfo.progress) > 0)) {
      //         this.taskStatusName = 'In Progress'
      //       } else {
      //         this.taskStatusName = 'Started'
      //       }
      //       this.taskStatusStyle = 'warning';
      //       break;
      //     case 3:
      //       this.taskStatusName = 'On Hold';
      //       this.taskStatusStyle = 'danger';
      //       break;
      //     case 4:
      //       this.taskStatusName = 'Done';
      //       this.taskStatusStyle = 'success';
      //       break;
      //     case 5:
      //       this.taskStatusName = 'In Progress';
      //       break;
      //   }
      // },
      taskInfo: function (val) {
        this.businessUnitCompanyUserList = this.taskInfo.businessUnitCompanyUserList
        this.businessUnitTaskCompanyUserList = this.taskInfo.businessUnitTaskCompanyUserList
        this.businessUnitTaskCompanyClientList = this.taskInfo.businessUnitTaskCompanyClientList
        this.businessUnitTaskCompanyVendorList = this.taskInfo.businessUnitTaskCompanyVendorList

        this.newVendorList = this.createMyList(val.businessUnitTaskCompanyVendorList, val.businessUnitTaskCompanyVendorPersonList, 'vendor')
        this.newClientList = this.createMyList(val.businessUnitTaskCompanyClientList, val.businessUnitTaskCompanyClientPersonList, 'clients')

        // remove from top start
        switch(val.status) {
          case 1:
            this.taskStatusName = 'Created';
            this.taskStatusStyle = 'info';
            break;
          case 2:
            if ((Math.round(val.progress) > 0)) {
              this.taskStatusName = 'In Progress'
            } else {
              this.taskStatusName = 'Started'
            }
            this.taskStatusStyle = 'warning';
            break;
          case 3:
            this.taskStatusName = 'On Hold';
            this.taskStatusStyle = 'danger';
            break;
          case 4:
            this.taskStatusName = 'Done';
            this.taskStatusStyle = 'success';
            break;
          case 5:
            this.taskStatusName = 'In Progress';
            break;
        }
        // remove from top end
      }
    },
    methods:{
      getProjects(businessUnitId, state, newCreatedBusinessUnitTask){
        this.$emit('getProjects', businessUnitId, state, newCreatedBusinessUnitTask)
      },
      getUserInfo(id){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/businessUnits/fieldInfo?companyId=${this.$route.query.companyId}&field=companyUser&companyUserId=${id}`)
          .then(response => {
            // console.log('hello2131231', response.data)
            this.tooltipUser = response.data.fieldInfo.user
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      createMyList(list, personList, state) {
        // console.log('list, personList, state', list, personList, state)
        const myList = [];

        for (let i = 0; i < list.length; i++) {
          myList.push({ ...list[i], people: [] })
          if(state === 'vendor'){
            for (let j = 0; j < personList.length; j++) {
              if (list[i].id === personList[j].companyVendorPerson.companyVendorId) {
                // console.log('list[i].companyVendorId', list[i].id )
                myList[i].people.push(personList[j])
                // personList.splice(j, 1)
              }
            }
          }
          if(state === 'clients'){
            for (let j = 0; j < personList.length; j++) {
              if (list[i].id === personList[j].companyClientPerson.companyClientId) {
                myList[i].people.push(personList[j])
                // personList.splice(j, 1)
              }
            }
          }
        }
        return myList
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      // changeBookMark (state, companyid, businessUnitId, taskId) {
      //   let data = this.bookmarkList;
      //   data.info = !this.bookmarkList.info;
      //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //   axios.post(`/api/v1/bookmarks/setBusinessUnitTask?companyId=${companyid}&businessUnitId=${businessUnitId}&businessUnitTaskId=${taskId}`, data)
      //     .then(response => {
      //       if (this.bookmarkList.info) {
      //         this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
      //       } else {
      //         this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
      //       }
      //     })
      //     .catch(error => {
      //     });
      // },
      handleClick(tab, event) {
        if(tab.name === "progress"){
            this.$store.dispatch('getDepProgressesList', this.selectedRow.id).then(list => {
              if (list.length && this.getStateId) {
                const progressItem = list.filter(val => val.id === this.getStateId);
                if (progressItem) {
                  this.$refs.buProgressTab.selectActiveProgressNode(this.getStateId);
                } else {
                  this.$store.dispatch('setStateId', null)
                }
              }
            });
            this.$store.dispatch('getTimerListDep', {businessUnitId: this.activeBusinessUnitId, businessUnitTaskId: this.selectedRow.id})
        }

        if(tab.name === "documents") {
            this.$store.dispatch('getDocumentsBU', this.selectedRow.id)
        }

        if (tab.name === 'toDo') {
            this.$store.dispatch('toDo', 'bu')
        }

        if (tab.name === 'about') {
            this.$store.dispatch('about', 'buTask')
        }

        if(tab.name === "eight"){
          this.$store.dispatch('getBusinessUnitTaskHistory', this.selectedRow.id)
        }
      }
    }
  }
</script>

<style lang="less" scoped>
    .about-task{
        display:none;
    }
    .about-task.open{
        display:block;
    }
    .el-row {
        margin-bottom: 20px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .el-col {
        border-radius: 4px;
    }
    .bg-purple-dark {
        background: #99a9bf;
    }
    .bg-purple {
        background: #d3dce6;
    }
    .bg-purple-light {
        background: #e5e9f2;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 36px;
        display:flex;
        align-items:center;
        font-weight:bold;
        padding:10px;
        font-size:14px;
        transition: .5s;
    }
    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }
    .card {
        .slot{
            margin:10px 0 0 0;
            padding-bottom:10px;
            border-bottom: 1px solid #ccc;
        }
        margin-bottom: 20px;
        .tag {
            margin-right: 5px;
        }
        &__no {
            display: flex;
            justify-content:space-between;
            /*align-items: center;*/
            font-weight: bold;
            padding-bottom: 5px;
            .name {
                margin-right: 10px;
            }
            .progress {
                flex: 1;
            }
        }
        &__name {
            font-weight: bold;
            padding-bottom: 5px;
        }
        &__task-name {
            font-size: 18px;
            border-bottom: 1px solid #ccc;
            padding-bottom: 5px;
        }
        &__location {
            padding-top: 5px;
            padding-bottom: 5px;
        }
        &__stat {
            padding-top: 5px;
            padding-bottom: 5px;
            border-bottom: 1px solid #ccc;
            span {
                font-weight: bold;
            }
        }
        &__by-to {
            padding-top: 5px;
            padding-bottom: 5px;
            border-bottom: 1px solid #ccc;
            span {
                font-weight: bold;
            }
        }
        &__btn {
            align-self: flex-end;
            // padding-top: 5px;
            // padding-bottom: 5px;
            // text-align: right;
            margin-left: 10px;
        }
    }

    .panel {
        min-width: 890px;
        margin-bottom: 20px;

        i.color {
            font-style: normal;
            color: #888
        }

        // Header
        &__header {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #EBEEF5;
            padding-bottom: 10px;
        }

        &__project-name {
            span {font-weight: bold;}
        }
        &__task-name {
            font-weight: bold;
            font-size: 20px;
        }
        &__progress {
            display: flex;
            justify-content: flex-end;
            padding-bottom: 5px;
            .el-progress {
                width: 350px;
            }
        }
        &__stage {
            min-width: 70px;
        }
        &__status {
            display: flex;
            justify-content: flex-end;
        }

        // Info
        &__info {
            // border-bottom: 1px solid #EBEEF5;
            padding: 10px 0 5px 0;
            position: relative;
        }
        &__date {
            display: flex;
            margin-bottom: 5px;
        }
        &__planned {
            width: 300px;
            span {font-weight: bold;}
        }
        &__actual {
            span {font-weight: bold;}
            i {font-style: normal;}
        }
        &__by-to {
            display: flex;
        }
        &__by {
            width: 300px;
            span {font-weight: bold;}
        }
        &__to {
            span {font-weight: bold;}
        }
        &__priority {
            position: absolute;
            top: calc(50% - 10px);
            right: 0;
        }

        // Description
        &__description {
            position: relative;
            // border-bottom: 1px solid #EBEEF5;
            padding: 5px 0;
        }

        &__gif {
            position: absolute;
            top: 18px;
            left: 0;
        }

        // Footer
        &__footer {
            display: flex;
            justify-content: space-between;
            min-height: 150px;
            padding: 5px 0;
        }
        &__team {
            width: 46%;
            padding: 0 10px 0 0;
            border-right: 1px solid #EBEEF5;
            &_title {
                // font-weight: bold;
                font-size: 16px;
            }
            &_item {
                cursor: pointer;
                margin-left: 25px;
                line-height: 1.5;
                // color: #4277A6;
                color: black;
            }
        }
        &__clients {
            width: 27%;
            padding: 0 10px;
            border-right: 1px solid #EBEEF5;
            &_title {
                font-weight: bold;
            }
            &_item {
                cursor: pointer;
                margin-left: 22px;
            }
        }
        &__vendors {
            width: 27%;
            padding: 0 0 0 10px;
            &_title {
                font-weight: bold;
            }
            &_item {
                cursor: pointer;
                margin-left: 22px;
            }
        }
    }
    .vendor{
        font-weight:bold;
    }
    p {
        img {
            max-width: 100%;
        }
    }
    .title_disabled {
        color: #ccc;
        font-weight: 500;
        text-decoration: underline;
        margin-bottom: 5px;
        // text-transform: uppercase;
    }
    .title_reoccuring_deadline {
      color: #409EFF;
      font-weight: 500;
      text-decoration: underline;
      margin-bottom: 5px;
    //   text-transform: uppercase;
    }
</style>
